import React, { useCallback, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { useNavigation, useTheme } from '@react-navigation/native'
import { WebSidebar } from './WebSidebar'
import { WebHeader } from './WebHeader'
import { Theme } from '@theme'
import { WebFooter } from './WebFooter'
import { useScreen } from '../../hooks/useScreen'
import { useCurrentUserStore } from '@store'
import { useExtension } from '../../hooks/useExtension'
import { GlobalSearchModal } from '@components'
import { useTrackLocation } from '../../hooks/useTrackLocation'

interface WebLayoutProps {
  children: React.ReactNode
}

export const WebLayout: React.FC<WebLayoutProps> = ({ children }) => {
  const theme = useTheme()
  const { responsivePadding, isDesktop } = useScreen()
  const styles = getStyle(theme, responsivePadding)
  const {isExtension} = useExtension()
  const {userID} = useCurrentUserStore()

  const isUserLogged = !!userID

  // Track user location on login (throttled to 30min)
  useTrackLocation(isUserLogged)

  const [sidebarCollapsed, setSidebarCollapsed] = useState(!isDesktop)
  const [searchVisible, setSearchVisible] = useState(false)

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  const navigation = useNavigation()

  const handleSearchPress = () => {
    setSearchVisible(true)
  }

  const handleNotificationsPress = useCallback(() => {
    ;(navigation as any).navigate('Tab', { screen: 'Notifications' })
  }, [navigation])

  const handleMessagesPress = useCallback(() => {
    ;(navigation as any).navigate('Tab', { screen: 'ListMessages' })
  }, [navigation])

  return (
    <View style={styles.container}>
      {isUserLogged && <WebHeader onSearchPress={handleSearchPress} onNotificationsPress={handleNotificationsPress} onMessagesPress={handleMessagesPress} isCollapsed={sidebarCollapsed} isExtension={isExtension} onToggleSidebar={toggleSidebar} />}
      <View style={styles.content}>
        {isUserLogged && <WebSidebar 
          isCollapsed={sidebarCollapsed} 
          onToggle={toggleSidebar} 
        />}
        <View style={styles.mainContent}>
          {children}
        </View>
      </View>
      {!isExtension && <WebFooter />}
      {isUserLogged && <GlobalSearchModal visible={searchVisible} onClose={() => setSearchVisible(false)} />}
    </View>
  )
}

const getStyle = (theme: Theme, padding: number) => {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    content: {
      flex: 1,
      flexDirection: 'row',
    },
    mainContent: {
      flex: 1,
      margin: padding,
      //marginVertical: theme.spacing.md + padding,
      overflow: 'hidden',
      //transition: 'margin-left 0.3s ease' as any,
    },
  })
}
